<script>
  import { hooksStore } from "../../../../stores/hooks.store";
  import { tempStore } from "../../../../stores/temp.store";

  import { zrusit, upravPoznamku } from "../poznamky.func";
  import { viditelnostTabu } from "../../sidebarLeft.func";
  import { getMap, pointTo } from "../../../../helpers/map";
  import { Draw } from "../../Controls/mapboxDraw";

  import { onDestroy, afterUpdate } from "svelte";
  import get from "get-value";
  import find from "lodash/find";

  export let kodMenu;
  let color, name, description, pub, draws;
  let formularIsOpen = false;
  let layer;
  let messages = { errors: [], successes: [] };
  let form;
  let tlacitkoOdoslat = "Uložiť";
  let poznamkaId;
  let sourceId;
  let popup;
  let kreslenia = [];
  let kresleniaKPoznamke = [];

  const unsubscribeTemp = tempStore.subscribe((value) => {
    kreslenia = get(value, "kreslenia.features") || [];
    kresleniaKPoznamke = get(value, "kresleniaKPoznamke") || {};

    kreslenia.map((k) => {
      if (poznamkaId && get(kresleniaKPoznamke, poznamkaId)) {
        k.checked = kresleniaKPoznamke[poznamkaId].includes(k.id);
        k.priradene = kresleniaKPoznamke[poznamkaId].includes(k.id);
      }
    });
    upravInputKreslenia();
  });

  hooksStore.addAction(
    "zobrazFormularNaPoznamku",
    "Formular.svelte",
    zobrazFormularNaPoznamku
  );

  hooksStore.addAction("skryFormularNaPoznamku", "Formular.svelte", () => {
    formularIsOpen = false;
  });

  hooksStore.addFilter("formMessages", "formular.svelte", formMessages);
  hooksStore.addFilter("formReset", "formular.svelte", formReset);

  function formMessages(msgs) {
    messages = msgs;
  }

  function formReset() {
    layer = "";
    poznamkaId = "";
    popup = "";
    color = "";
    name = "";
    pub = "";
    sourceId = "";
    description = "";
    document
      .querySelectorAll('.poznamky-formular input[name="kreslenia"]:checked')
      .forEach((element) => {
        element.checked = false;
      });
  }

  function zobrazFormularNaPoznamku(data) {
    viditelnostTabu(kodMenu, true);

    hooksStore.doAction("zrusitZormularPoznamky", sourceId, poznamkaId);

    formularIsOpen = true;
    // layer = data.geojson;
    poznamkaId = data.poznamka_id || null;
    sourceId = data.sourceId || null;
    popup = data.popup || null;
    color = data.color;
    name = data.title;
    pub = data.public;
    description = data.note_desc;
  }

  function upravInputKreslenia() {
    const zakliknuteKreslenia = document.querySelectorAll(
      '.poznamky-formular input[name="kreslenia"]:checked'
    );
    // if (zakliknuteKreslenia.length) {
    let featureCollection = {
      type: "FeatureCollection",
      features: [],
    };

    const features = [].map.call(zakliknuteKreslenia, (el) => {
      return find(kreslenia, (k) => k.id === el.value);
    });
    if (features.length) {
      featureCollection.features = features;
      layer = JSON.stringify(featureCollection);
    } else {
      layer = "";
    }
    // }
  }

  function zvyrazni(kreslenieId, highlight = true) {
    const map = getMap();
    let highlightedFeatures = [];
    map
      .querySourceFeatures("mapbox-gl-draw-hot", {
        filter: ["==", "id", kreslenieId],
      })
      .map((k) => {
        if (k.properties && !highlightedFeatures.includes(k.properties.id)) {
          highlightedFeatures.push(k.properties.id);
        }
      });
    map
      .querySourceFeatures("mapbox-gl-draw-cold", {
        filter: ["==", "id", kreslenieId],
      })
      .map((k) => {
        if (k.properties && !highlightedFeatures.includes(k.properties.id)) {
          highlightedFeatures.push(k.properties.id);
        }
      });

    highlightedFeatures.forEach(function (id) {
      Draw.setFeatureProperty(id, "hover", highlight ? "true" : "false");
      Draw.add(Draw.get(id));
    });
  }

  function doPointTo(kreslenieId) {
    Draw.getAll().features.map((d) => {
      if (d.id === kreslenieId) {
        pointTo({
          type: "FeatureCollection",
          features: [d],
        });
      }
    });
  }

  onDestroy(unsubscribeTemp);
  afterUpdate(() => {
    upravInputKreslenia();
  });
</script>

<div class="poznamky-formular" class:formularIsOpen>
  <form
    on:submit|preventDefault={(e) => upravPoznamku(popup, form)}
    bind:this={form}
  >
    <h6 class="sidebar__heading">Upraviť vybranú poznámku</h6>
    <div class="input-group">
      <label class="input__label" for="note-name">Názov</label>
      <input
        type="text"
        id="note-name"
        class="input input-margin"
        name="name"
        bind:value={name}
      />
    </div>

    <div class="input-group">
      <label class="input__label" for="note">Poznámka</label>
      <textarea
        name="description"
        id="note"
        class="input input-margin"
        cols="30"
        rows="10"
        bind:value={description}
      />
    </div>

    <div class="input-group">
      <label class="input__label" for="note-color">Farba</label>
      <input
        type="color"
        id="note-color"
        class="input input-margin"
        bind:value={color}
        name="color"
      />
    </div>

    <div class="input-group">
      <label class="checkbox">
        <input
          name="public"
          bind:group={pub}
          type="radio"
          id="public"
          value="1"
        />
        <label for="public">Verejné</label>
      </label>
    </div>

    <div class="input-group">
      <label class="checkbox">
        <input
          name="public"
          bind:group={pub}
          type="radio"
          id="private"
          value="0"
        />
        <label for="private">Súkromné</label>
      </label>
    </div>

    <div class="aktivneKreslenia">
      <h7 class="sidebar__heading">Aktívne kreslenia</h7>
      {#each kreslenia as kreslenie, i}
        {@const typeName =
          get(kreslenie, "geometry.type") === "LineString"
            ? "Línia"
            : get(kreslenie, "geometry.type") === "Polygon"
            ? "Polygón"
            : get(kreslenie, "geometry.type") === "Point"
            ? "Bod"
            : ""}
        <div
          class="input-group"
          on:mouseenter={() => zvyrazni(kreslenie.id)}
          on:mouseleave={() => zvyrazni(kreslenie.id, false)}
        >
          <div class="header">
            <label class="checkbox">
              <input
                name="kreslenia"
                type="checkbox"
                id="kreslenie_{kreslenie.id}"
                value={kreslenie.id}
                on:change={() => upravInputKreslenia()}
                bind:checked={kreslenie.checked}
              />
              <label for="kreslenie_{kreslenie.id}">{typeName}</label>
            </label>
            <span class="tlacitka">
              <span on:click={() => doPointTo(kreslenie.id)}>
                <!-- JSON icon location start -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  viewBox="0 0 370.854 511.999"
                  fill="currentColor"
                >
                  <g transform="translate(-70.573)">
                    <g>
                      <path
                        d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173,321.035a16.7,16.7,0,0,0,24.846,0c7.065-7.868,173-194.147,173-321.035C441.425,83.182,358.244,0,256,0Zm0,278.719a93.292,93.292,0,1,1,93.291-93.292A93.4,93.4,0,0,1,256,278.719Z"
                      />
                    </g>
                  </g>
                </svg>
                <!-- JSON icon location end -->
              </span>
            </span>
          </div>
          <div class="sys-data">{@html kreslenie.properties.sysData || ""}</div>
          <div class="priradenie" class:priradene={kreslenie.priradene}>
            {kreslenie.priradene
              ? "Objekt k editovanej poznámke"
              : "Nový objekt"}
          </div>
        </div>
      {/each}
    </div>

    <div class="input-group input-group--cta">
      <input type="hidden" name="layer" bind:value={layer} />
      <input type="hidden" name="id" bind:value={poznamkaId} />
      <input type="hidden" name="sourceId" bind:value={sourceId} />
      <div id="response">
        {#if messages.errors}
          {#each messages.errors as error}
            <div class="error">{error}</div>
          {/each}
        {/if}
        {#if messages.successes}
          {#each messages.successes as success}
            <div class="success">{success}</div>
          {/each}
        {/if}
      </div>
      <input
        type="submit"
        class="btn btn--block btn--mb"
        value={tlacitkoOdoslat}
      />
      <button
        type="submit"
        class="btn btn--secondary btn--block"
        on:click={(e) => zrusit(sourceId, poznamkaId)}>Zrušiť</button
      >
    </div>
  </form>
</div>

<style lang="scss">
  .aktivneKreslenia .input-group {
    padding-bottom: 10px;
    border-bottom: 1px solid #dbdbdb;
  }
  .poznamky-formular {
    display: none;
    &.formularIsOpen {
      display: block;
    }
  }
  #response {
    margin-bottom: 20px;
    text-align: center;
    font-size: 17px;
    .error {
      color: #c24141;
    }
    .success {
      color: #008000;
    }
  }

  .sys-data {
    padding-left: 2rem;
    font-size: var(--text-xs);
  }

  .header {
    height: auto;
    background: none;
    margin: 10px 0 0;
    padding: 0;
    display: flex;
    justify-content: space-between;

    &::before {
      display: none;
    }

    .tlacitka {
      & > span {
        cursor: pointer;
      }
    }
  }

  .priradenie {
    padding-left: 2rem;
    font-size: var(--text-xs);
    color: red;
    opacity: 0.4;

    &.priradene {
      color: green;
    }
  }
</style>
